(function () {
  var KEY = "roovia_offer_copied_until";
  var MOUNT_ID = "roovia-bottom-offer";

  function qs(sel) { return document.querySelector(sel); }
  function qsa(sel) { return document.querySelectorAll(sel); }

  function isCheckoutPath() {
    var p = window.location.pathname || "";
    return p.indexOf("/checkout") === 0 || p.indexOf("/checkouts") === 0;
  }

  function isArabicContext() {
    try {
      var html = document.documentElement;
      var lang = (html.getAttribute("lang") || "").toLowerCase();
      var dir = (html.getAttribute("dir") || "").toLowerCase();
      return lang.indexOf("ar") === 0 || dir === "rtl";
    } catch (e) {
      return false;
    }
  }

  function shouldReset() {
    try { return (window.location.search || "").indexOf("roovia_offer_reset=1") !== -1; }
    catch (e) { return false; }
  }

  function clearHide() { try { localStorage.removeItem(KEY); } catch (e) {} }

  function getSource() {
    var nodes = qsa("[data-roovia-source]");
    if (!nodes || !nodes.length) return null;
    return nodes[nodes.length - 1];
  }

  function getMounted() { return document.getElementById(MOUNT_ID); }
  function removeMounted() { var m = getMounted(); if (m && m.parentNode) m.parentNode.removeChild(m); }

  function isVisibilityHidden(source) {
    var v = (source.getAttribute("data-visibility") || "both").trim();
    var isDesktop = (window.innerWidth || 0) >= 750;
    if (v === "mobile" && isDesktop) return true;
    if (v === "desktop" && !isDesktop) return true;
    return false;
  }

  function isTemplateHidden(source) {
    var pageType = (source.getAttribute("data-page-type") || "").trim();
    var hp = (source.getAttribute("data-hide-product") || "false") === "true";
    var hc = (source.getAttribute("data-hide-collection") || "false") === "true";
    var hcart = (source.getAttribute("data-hide-cart") || "false") === "true";
    if (hp && pageType === "product") return true;
    if (hc && pageType === "collection") return true;
    if (hcart && pageType === "cart") return true;
    return false;
  }

  function canShow(source) {
    if (!source) return false;
    if (isCheckoutPath()) return false;

    if (shouldReset()) { clearHide(); return true; }
    if (isTemplateHidden(source)) return false;
    if (isVisibilityHidden(source)) return false;

    var hideEnabled = (source.getAttribute("data-hide-enabled") || "false") === "true";
    if (!hideEnabled) return true;

    var days = parseInt(source.getAttribute("data-dismiss-days") || "0", 10);
    if (isNaN(days) || days <= 0) return true;

    try {
      var until = parseInt(localStorage.getItem(KEY) || "0", 10);
      if (until && Date.now() < until) return false;
    } catch (e) {}

    return true;
  }

  function weightForStyle(style) {
    var fw = (style || "black").trim();
    if (fw === "regular") return 400;
    if (fw === "bold") return 600;
    return 800;
  }

  function applyTextWeight(mounted, style) {
    var w = weightForStyle(style);
    mounted.style.setProperty("--text-weight", String(w));
    var textEl = mounted.querySelector(".roovia-offer__text");
    if (textEl) textEl.style.fontWeight = String(w);
  }

  function applyTextSizeClass(mounted, sizeKey) {
    // sizeKey: small | medium | large
    var s = (sizeKey || "medium").trim();
    if (s !== "small" && s !== "medium" && s !== "large") s = "medium";

    mounted.classList.remove("roovia-text--small", "roovia-text--medium", "roovia-text--large");
    mounted.classList.add("roovia-text--" + s);
  }

  function setVars(mounted, source) {
    var bg = (source.getAttribute("data-bg") || "").trim();
    var tc = (source.getAttribute("data-text-color") || "").trim();
    if (bg) mounted.style.setProperty("--roovia-bg", bg);
    if (tc) mounted.style.setProperty("--roovia-text", tc);

    // ✅ Text size: Arabic uses data-text-size-ar when RTL/lang ar
    var defaultSize = (source.getAttribute("data-text-size") || "medium").trim();
    var arabicSize = (source.getAttribute("data-text-size-ar") || defaultSize).trim();
    var sizeToUse = isArabicContext() ? arabicSize : defaultSize;

    // Apply class that CSS maps to --text-size-m / --text-size-d
    applyTextSizeClass(mounted, sizeToUse);

    // Keep old variable behavior as a safe fallback if your CSS mapping isn't present
    // (does not override class mapping unless your CSS uses these variables directly)
    if (sizeToUse === "small") {
      mounted.style.setProperty("--text-size-m", "14px");
      mounted.style.setProperty("--text-size-d", "15px");
    } else if (sizeToUse === "large") {
      mounted.style.setProperty("--text-size-m", "18px");
      mounted.style.setProperty("--text-size-d", "20px");
    } else {
      mounted.style.setProperty("--text-size-m", "16px");
      mounted.style.setProperty("--text-size-d", "18px");
    }

    applyTextWeight(mounted, source.getAttribute("data-text-style") || "black");

    var be = (source.getAttribute("data-border-enable") || "false") === "true";
    var bw = parseInt(source.getAttribute("data-border-width") || "0", 10);
    var bc = (source.getAttribute("data-border-color") || "").trim();
    if (!be) bw = 0;
    if (isNaN(bw)) bw = 0;
    mounted.style.setProperty("--roovia-border-width", bw + "px");
    mounted.style.setProperty("--roovia-border-color", bc || "transparent");

    var bottom = parseInt(source.getAttribute("data-bottom") || "14", 10);
    if (isNaN(bottom)) bottom = 14;
    mounted.style.setProperty("--roovia-bottom", bottom + "px");

    var radius = parseInt(source.getAttribute("data-radius") || "500", 10);
    if (isNaN(radius)) radius = 500;
    mounted.style.setProperty("--roovia-radius", radius + "px");

    var r = source.getAttribute("data-shadow-r") || "0";
    var g = source.getAttribute("data-shadow-g") || "0";
    var b = source.getAttribute("data-shadow-b") || "0";
    var y = parseInt(source.getAttribute("data-shadow-y") || "0", 10);
    var blur = parseInt(source.getAttribute("data-shadow-blur") || "0", 10);
    var op = parseFloat(source.getAttribute("data-shadow-opacity") || "0");
    if (isNaN(y)) y = 0;
    if (isNaN(blur)) blur = 0;
    if (isNaN(op)) op = 0;

    var a = Math.max(0, Math.min(1, op / 100));
    mounted.style.setProperty("--roovia-shadow-r", String(r));
    mounted.style.setProperty("--roovia-shadow-g", String(g));
    mounted.style.setProperty("--roovia-shadow-b", String(b));
    mounted.style.setProperty("--roovia-shadow-y", y + "px");
    mounted.style.setProperty("--roovia-shadow-blur", blur + "px");
    mounted.style.setProperty("--roovia-shadow-a", String(a));
  }

  function persistHide(source) {
    var hideEnabled = (source.getAttribute("data-hide-enabled") || "false") === "true";
    if (!hideEnabled) return;

    var days = parseInt(source.getAttribute("data-dismiss-days") || "0", 10);
    if (isNaN(days) || days <= 0) return;

    try {
      localStorage.setItem(KEY, String(Date.now() + days * 24 * 60 * 60 * 1000));
    } catch (e) {}
  }

  async function copy(text) {
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(text);
        return true;
      }
    } catch (e) {}

    try {
      var ta = document.createElement("textarea");
      ta.value = text;
      ta.setAttribute("readonly", "");
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.select();
      ta.setSelectionRange(0, ta.value.length);
      var ok = document.execCommand("copy");
      document.body.removeChild(ta);
      return ok;
    } catch (e2) {
      return false;
    }
  }

  function setPillText(mounted, text) {
    var el = mounted.querySelector(".roovia-offer__text");
    if (el) el.textContent = text;
  }

  function getInt(source, attr, fallback) {
    var v = parseInt(source.getAttribute(attr) || "", 10);
    return isNaN(v) ? fallback : v;
  }

  function getConfettiColors(source) {
    var tc = (source.getAttribute("data-text-color") || "#111111").trim();
    var bc = (source.getAttribute("data-border-color") || "#111111").trim();
    return [tc, bc, "#EAA713", "#DC189B", "#1F2A44"];
  }

  function pickPerimeterPoint(rect) {
    // random point around pill perimeter
    var t = Math.random();
    var side = Math.floor(Math.random() * 4); // 0 top, 1 right, 2 bottom, 3 left
    if (side === 0) return { x: rect.left + t * rect.width, y: rect.top };
    if (side === 1) return { x: rect.right, y: rect.top + t * rect.height };
    if (side === 2) return { x: rect.left + t * rect.width, y: rect.bottom };
    return { x: rect.left, y: rect.top + t * rect.height };
  }

  function shapeFor(source) {
    var s = (source.getAttribute("data-confetti-shape") || "mixed").trim();
    if (s === "mixed") {
      var opts = ["dots", "squares", "pills", "ribbons"];
      return opts[Math.floor(Math.random() * opts.length)];
    }
    return s;
  }

  function styleConfettiPiece(el, shape, color) {
    // base
    el.style.background = color;
    el.style.opacity = "0";
    el.style.position = "fixed";
    el.style.willChange = "transform, opacity";
    el.style.backfaceVisibility = "hidden";
    el.style.webkitBackfaceVisibility = "hidden";

    if (shape === "dots") {
      var sz = 6 + Math.random() * 4; // 6-10
      el.style.width = sz + "px";
      el.style.height = sz + "px";
      el.style.borderRadius = "999px";
      return;
    }

    if (shape === "squares") {
      var s = 6 + Math.random() * 5; // 6-11
      el.style.width = s + "px";
      el.style.height = s + "px";
      el.style.borderRadius = "2px";
      return;
    }

    if (shape === "pills") {
      var w = 10 + Math.random() * 10; // 10-20
      var h = 4 + Math.random() * 3;  // 4-7
      el.style.width = w + "px";
      el.style.height = h + "px";
      el.style.borderRadius = "999px";
      return;
    }

    // ribbons
    var rw = 14 + Math.random() * 14; // 14-28
    var rh = 3 + Math.random() * 3;   // 3-6
    el.style.width = rw + "px";
    el.style.height = rh + "px";
    el.style.borderRadius = "2px";
  }

  function burstConfetti(btnEl, source) {
    var anim = (source.getAttribute("data-animation") || "confetti").trim();
    if (anim !== "confetti") return;

    var count = getInt(source, "data-confetti-count", 22);
    var dur = getInt(source, "data-confetti-duration", 650);
    var distBase = getInt(source, "data-confetti-distance", 70);

    if (!btnEl || !btnEl.getBoundingClientRect) return;
    if (count <= 0 || dur <= 0) return;

    var rect = btnEl.getBoundingClientRect();

    var wrap = document.createElement("div");
    wrap.setAttribute("aria-hidden", "true");
    wrap.style.position = "fixed";
    wrap.style.left = "0";
    wrap.style.top = "0";
    wrap.style.width = "100%";
    wrap.style.height = "100%";
    wrap.style.pointerEvents = "none";
    wrap.style.zIndex = "1000000";
    wrap.style.contain = "layout paint";
    wrap.style.isolation = "isolate";

    document.body.appendChild(wrap);

    var colors = getConfettiColors(source);

    // More "inclusive around pill": 360 spread + perimeter origins
    for (var i = 0; i < count; i++) {
      var p = document.createElement("span");
      var color = colors[Math.floor(Math.random() * colors.length)];
      var shape = shapeFor(source);

      styleConfettiPiece(p, shape, color);

      var origin = pickPerimeterPoint(rect);

      p.style.left = origin.x + "px";
      p.style.top = origin.y + "px";
      p.style.transform = "translate3d(0,0,0) rotate(0deg)";

      wrap.appendChild(p);

      var angle = Math.random() * Math.PI * 2; // 360
      var dist = (distBase * 0.75) + (Math.random() * distBase * 0.85);
      var dx = Math.cos(angle) * dist;

      // slight upward bias so it feels premium (less falling down)
      var dyRaw = Math.sin(angle) * dist;
      var dy = dyRaw > 0 ? dyRaw * 0.55 : dyRaw * 1.05;

      var rot = (Math.random() * 320 - 160);
      var delay = Math.floor(Math.random() * 90); // stagger 0-90ms

      if (p.animate) {
        p.animate(
          [
            { opacity: 0, transform: "translate3d(0,0,0) rotate(0deg) scale(0.9)" },
            { opacity: 1, transform: "translate3d(" + (dx * 0.35) + "px," + (dy * 0.35) + "px,0) rotate(" + (rot * 0.35) + "deg) scale(1)" },
            { opacity: 0, transform: "translate3d(" + dx + "px," + dy + "px,0) rotate(" + rot + "deg) scale(0.98)" }
          ],
          { duration: dur, delay: delay, easing: "cubic-bezier(.2,.8,.2,1)", fill: "forwards" }
        );
      }
    }

    setTimeout(function () {
      if (wrap && wrap.parentNode) wrap.parentNode.removeChild(wrap);
    }, dur + 140);
  }

  function mount() {
    var source = getSource();
    if (!source) { removeMounted(); return; }

    removeMounted();

    var mounted = source.cloneNode(true);
    mounted.id = MOUNT_ID;
    mounted.classList.remove("roovia-offer--source");
    mounted.removeAttribute("hidden");
    mounted.removeAttribute("data-roovia-source");

    var toastEl = mounted.querySelector(".roovia-offer__toast");
    if (toastEl) toastEl.hidden = true;

    setVars(mounted, source);
    document.body.appendChild(mounted);

    if (!canShow(source)) {
      mounted.hidden = true;
      mounted.classList.remove("roovia-offer--ready");
      return;
    }

    mounted.hidden = false;
    requestAnimationFrame(function () { mounted.classList.add("roovia-offer--ready"); });

    var btn = mounted.querySelector("[data-roovia-copy]");
    if (!btn) return;

    var busy = false;
    var revertTimer = null;

    btn.addEventListener("click", async function () {
      if (busy) return;
      busy = true;

      var liveSource = getSource() || source;

      var defaultText = liveSource.getAttribute("data-button") || "";
      var copiedText = liveSource.getAttribute("data-toast") || "Code copied";
      var copiedDuration = getInt(liveSource, "data-copied-duration", 900);

      var defaultStyle = (liveSource.getAttribute("data-text-style") || "black").trim();
      var copiedStyle = (liveSource.getAttribute("data-copied-text-style") || defaultStyle).trim();

      var defaultBg = (liveSource.getAttribute("data-bg") || "").trim();
      var copiedBg = (liveSource.getAttribute("data-copied-bg") || "").trim();

      var code = liveSource.getAttribute("data-code") || "";
      if (!code) { busy = false; return; }

      var ok = await copy(code);

      if (ok) {
        burstConfetti(btn, liveSource);

        applyTextWeight(mounted, copiedStyle);
        if (copiedBg) mounted.style.setProperty("--roovia-bg", copiedBg);
        setPillText(mounted, copiedText);

        if (revertTimer) clearTimeout(revertTimer);
        revertTimer = setTimeout(function () {
          applyTextWeight(mounted, defaultStyle);
          if (defaultBg) mounted.style.setProperty("--roovia-bg", defaultBg);
          setPillText(mounted, defaultText);
        }, Math.max(0, copiedDuration));

        persistHide(liveSource);
      }

      setTimeout(function () { busy = false; }, 140);
    });
  }

  function boot() {
    if (!document.body) return;
    if (shouldReset()) clearHide();
    mount();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();

  window.addEventListener("load", boot);
  window.addEventListener("pageshow", boot);
  window.addEventListener("resize", boot);

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener("shopify:section:load", boot);
    document.addEventListener("shopify:section:select", boot);
    document.addEventListener("shopify:section:reorder", boot);
    document.addEventListener("shopify:section:deselect", boot);
    document.addEventListener("shopify:section:settings:change", function () { boot(); });
  }
})();
